import React from 'react';
import ThemeProvider from 'providers/ThemeProvider';
import CommandPalette from 'components/common/CommandPalette';
import { inject } from '@vercel/analytics';
import './src/styles/global.css';

// Dev-only overlay. The NODE_ENV check is inlined at build time, so the
// production bundle drops the module (and its static query) entirely.
const DevRibbon =
  process.env.NODE_ENV === 'development'
    ? require('components/common/DevRibbon').default
    : null;

// Initialize Vercel Analytics in the browser
inject();

export const onServiceWorkerUpdateReady = () => window.location.reload(true);

export const wrapRootElement = ({ element }) => {
  return (
    <ThemeProvider>
      {element}
      <CommandPalette />
      {DevRibbon && <DevRibbon />}
    </ThemeProvider>
  );
};
